import { render, staticRenderFns } from "./PricingDetail.vue?vue&type=template&id=4f33b32d&scoped=true"
import script from "./PricingDetail.vue?vue&type=script&lang=js"
export * from "./PricingDetail.vue?vue&type=script&lang=js"
import style0 from "./PricingDetail.vue?vue&type=style&index=0&id=4f33b32d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f33b32d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f33b32d')) {
      api.createRecord('4f33b32d', component.options)
    } else {
      api.reload('4f33b32d', component.options)
    }
    module.hot.accept("./PricingDetail.vue?vue&type=template&id=4f33b32d&scoped=true", function () {
      api.rerender('4f33b32d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/vehiclelookup/PricingDetail.vue"
export default component.exports